<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'BaseChartLine',
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  watch: {
    chartData: function () {
      this.update()
    },
    options: function () {
      this.update()
    },
  },
  mounted() {
    this.update()
  },
  methods: {
    update: function () {
      this.renderChart(this.chartData, this.options)
    },
  },
}
</script>
